// Referral + signup-source attribution helpers (epic #293 phase 1).
// A member's referral link is /signup?ref=<code>; the code sticks in
// localStorage so it survives browsing around before the form, and
// both the /join form and the /signup flow submit it alongside a
// structured "how did you hear about us" answer. All best-effort —
// attribution must never break a signup.

const REF_LS_KEY = "ab-refCode";
const REF_MAX = 40;

export const getStoredRef = () => {
  try {
    return (localStorage.getItem(REF_LS_KEY) || "").slice(0, REF_MAX);
  } catch (e) {
    return "";
  }
};

// Read ?ref= from the current URL (persisting it) or fall back to a
// previously stored code. Call once on mount of /join and /signup.
export const captureRefCode = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = String(params.get("ref") || "")
      .trim()
      .replace(/[^A-Za-z0-9_-]/g, "")
      .slice(0, REF_MAX);
    if (ref) {
      try {
        localStorage.setItem(REF_LS_KEY, ref);
      } catch (e) {
        // private mode — the in-memory value still gets submitted
      }
      return ref;
    }
  } catch (e) {
    // fall through to storage
  }
  return getStoredRef();
};

// Invite codes (ladies paywall): /signup?code=XXXXXXXX. Captured the
// same way as ref codes and redeemed from the dashboard once the
// person is signed in (SubscribeBanner auto-redeems a stored code).
const INVITE_LS_KEY = "ab-inviteCode";

export const getStoredInviteCode = () => {
  try {
    return (localStorage.getItem(INVITE_LS_KEY) || "").slice(0, 16);
  } catch (e) {
    return "";
  }
};

export const captureInviteCode = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = String(params.get("code") || params.get("invite") || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "")
      .slice(0, 16);
    if (code) {
      try {
        localStorage.setItem(INVITE_LS_KEY, code);
      } catch (e) {
        // private mode
      }
      return code;
    }
  } catch (e) {
    // fall through
  }
  return getStoredInviteCode();
};

export const clearStoredInviteCode = () => {
  try {
    localStorage.removeItem(INVITE_LS_KEY);
  } catch (e) {
    // ignore
  }
};

// A member's own shareable code: their Cognito sub, dashes stripped,
// first 10 chars — short enough to read out loud, unique enough for
// attribution (resolution back to the member is a prefix match).
export const buildReferralCode = (sub) =>
  sub ? String(sub).replace(/-/g, "").slice(0, 10) : "";

export const buildReferralLink = (sub) =>
  `https://activebeaches.com/signup?ref=${buildReferralCode(sub)}`;

// Structured source options shown on /join and /signup. "value" is
// what lands in the hearAbout attribute.
export const HEAR_ABOUT_OPTIONS = [
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "friend", label: "Friend / member" },
  { value: "google", label: "Google" },
  { value: "walked-up", label: "Met you at an event" },
  { value: "other", label: "Other" },
];
